<template>
    <div class="frmdashboard_cont">
        <GrcDB ref="GRCDB"></GrcDB>    
        <GrcDialog ref="Dialog"></GrcDialog>

        <GrcCombo ref="cboUgyfel" v-model="UgyfelID" grc_labeltext="Választott ügyfél:"
        grc_labelmode="above" grc_labelwidth="80px" grc_dropdownminwidth="300"  
        grc_keyfield="id" grc_displayfield="Megnevezes"
        grc_readonly="false"
        v-bind:grc_dropdown_columns="[{fieldname:'Megnevezes', width:'100%', cutlongtext:'true'}]"
        v-on:dropdownopened="SetPopupRef('cboUgyfel')"
        v-on:dropdownclosed="SetPopupRef('')"
        v-on:grc-keydown-enter="SetControlToFocus('');"
        v-on:innerindexbroadcast="cboUgyfel_InnerIndexBroadcasted"
        />

        <div v-show="NagykoruRegMeghivo==0" style="width:100%; box-sizing:border-box; display:block;">

            <frmDashboard_PMT ref="PMT" />

            <br>
            <h2 class="painted_header_h2 color3"><span><b>Biztosítások</b></span></h2>
            <br>

            <div style="width:100%; box-sizing:border-box; tex-align:left; margin:20px 0px; font-size:18px; line-height:24px; color:var(--themecolor1);">
                Tájékoztatjuk, hogy a biztosítási időszak a Biztosítási Feltételek alapján minden év április 1-től következő év március 31-ig tart.
            </div>

            <frmDashboard_BiztLista ref="BiztLista" />

            <br>
            <h2 class="painted_header_h2 color3"><span><b>Szolgáltatások</b></span></h2>
            <br>

            <frmDashboard_Szolgaltatasok ref="Szolgaltatasok" />        


            <frmDashboard_KritikusIgenyek ref="KritikusIgenyek" />


            <br><br>
            <h2 class="painted_header_h2 color3"><span><b>Folyamatban lévő ügyek</b></span></h2>
            <br>
            <frmDashboard_FolyamatbanLevoUgyek ref="FolyamatbanLevoUgyek" />

            <br>
            <a href="lezart-esemenyek" class="painted_linkbutton2 color3" style="margin: 4px 4px 4px 0px;">
                <span style="font-weight:500;">Lezárt eseményeim<i class="fal fa-angles-right" style="margin-left: 8px;"></i></span>
            </a>    
            <br><br>                                    

        </div>

        <div v-show="(NagykoruRegMeghivo==1)&&(NRM_formid==1)" style="width:100%; box-sizing:border-box; display:inline-block; font-size:16px; line-height:22px; color:#000; padding:20px 0px;">
            <div style="width:100%; box-sizing:border-box; display:inline-block; margin-bottom:30px;" v-html="NagykoruRegMeghivo_infotext"></div>

            <div class="nrm_col1">
                <GrcText ref="txtEmailCim"
                grc_labeltext="E-mail cím:"
                grc_placeholder="..."
                grc_labelmode="" grc_labelwidth="200px" 
                />
            </div>
            <div class="nrm_col2">
                <span @click="btnNRM_send_click" class="painted_linkbutton2 color3" style="margin: 4px 8px;">
                    <span><i class="fal fa-check" style="margin-right: 10px;"></i>Küldés</span>
                </span>                                        
            </div>


        </div>

        <div v-show="(NagykoruRegMeghivo==1)&&(NRM_formid==2)" style="width:100%; box-sizing:border-box; display:inline-block; font-size:18px; line-height:24px; color:#000; padding:20px 0px;">
            <div style="width:100%; box-sizing:border-box; display:inline-block; margin-bottom:30px;" v-html="NagykoruRegMeghivo_sikerestext"></div>

        </div>


    </div>
</template>

<script>

import GrcText from '../GrcComponents/GrcText.vue'
import GrcButton from '../GrcComponents/GrcButton.vue'
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcCheckboxMobile from '../GrcComponents/GrcCheckboxMobile.vue'
import GrcCombo from '../GrcComponents/GrcCombo.vue'

import frmDashboard_BiztLista from '../frmdashboard/frmDashboard_BiztLista.vue'
import frmDashboard_FolyamatbanLevoUgyek from '../frmdashboard/frmDashboard_FolyamatbanLevoUgyek.vue'
import frmDashboard_Szolgaltatasok from '../frmdashboard/frmDashboard_Szolgaltatasok.vue'
import frmDashboard_KritikusIgenyek from '../frmdashboard/frmDashboard_KritikusIgenyek.vue'
import frmDashboard_PMT from '../frmdashboard/frmDashboard_PMT.vue'

export default {
  name: 'frmdashboard',
  components: {
      GrcText,
      GrcButton,
      GrcDB,
      GrcDialog,
      GrcCheckboxMobile,
      GrcCombo,
      frmDashboard_BiztLista,
      frmDashboard_FolyamatbanLevoUgyek,
      frmDashboard_Szolgaltatasok,
      frmDashboard_KritikusIgenyek,
      frmDashboard_PMT,
  },
  props: {
  },
  data () {
      return {
          WSPREFIX: "frmDashboard_",

          UgyfelID:0,
          UGYFELLIST:[],
          DashboardUgyfelID:0,
          NagykoruRegMeghivo:-1,
          NagykoruRegMeghivo_infotext:"",
          NagykoruRegMeghivo_sikerestext:"",
          NRM_formid:0,

      }
  },
  model: {

  },  
  methods:{

    async btnNRM_send_click()
    {
        var ErrorCompName = "";
        if (grcmain_IsValidEmailAddress(this.$refs.txtEmailCim.GetText()) == false)
        {
          if (ErrorCompName == "") { ErrorCompName = "txtEmailCim"; }
          if (this.$refs.txtEmailCim.GetText() == "")
          {
            this.$refs.txtEmailCim.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
          }
          else
          {
            this.$refs.txtEmailCim.ShowError(grcmain_GetTextBookItem("tech", "email_format_error"));
          }
        }

        if (ErrorCompName != "")
        {
          this.SetControlToFocus(ErrorCompName);
          return;
        }

        this.$refs.GRCDB.ShowLoading(false);

        var QP = { 
            sSessionID: "[APPSESSIONID]",
            iUgyfelID: gDashboardUgyfelID,
            sEmailCim: this.$refs.txtEmailCim.GetText().trim(),
        };

        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "KNR_Reg_Mentes", QP).then(res => { Q = res; });


        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            this.$emit("handlecommerror", Q.APPERR[0].ERR);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        if (Q.RESULT[0].intResult == 1)
        {
            this.NRM_formid = 2;
        }



    },

    SetPopupRef(pRef)
    {
        gPopupControlName = pRef;
    },

    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmDashboard", pCompName);
    },

    SetLang()
    {
        this.NagykoruRegMeghivo_infotext = this.GetTextBookItem("nagykoru_reg_meghivo_infotext");
        this.NagykoruRegMeghivo_sikerestext = this.GetTextBookItem("nagykoru_reg_meghivo_sikeres_text");
        
      /*
        this.$refs.txtEmailCim.SetLabel(this.GetTextBookItem("txtEmailCim"));
      */

     this.Init();

    },

    cboUgyfel_InnerIndexBroadcasted(pIndex)
    {
        if (this.DashboardUgyfelID != this.UGYFELLIST[pIndex].id)
        {
            this.DashboardUgyfelID = this.UGYFELLIST[pIndex].id;
            gDashboardUgyfelID = this.DashboardUgyfelID;

            this.LoadWidgets();
        }
    },

    async LoadWidgets()
    {
        this.NagykoruRegMeghivo = -1;
        this.NRM_formid = 0;

        for(let i=0; i<this.UGYFELLIST.length; i++)
        {
            if (this.UGYFELLIST[i].id == gDashboardUgyfelID)
            {
                this.NagykoruRegMeghivo = this.UGYFELLIST[i].NagykoruRegMeghivo;
                this.NRM_formid = 1;
            }
        }
        
        if (this.NagykoruRegMeghivo == 0)
        {
            this.$refs.PMT.Init();
            this.$refs.BiztLista.Init();
            this.$refs.Szolgaltatasok.Init();
            this.$refs.KritikusIgenyek.Init();
            this.$refs.FolyamatbanLevoUgyek.Init();
        }
    },


    async Init()
    {
        this.$refs.GRCDB.ShowLoading(false);

        var QP = { 
            sSessionID: "[APPSESSIONID]"
        };

        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "Init_V2", QP).then(res => { Q = res; });


        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            this.$emit("handlecommerror", Q.APPERR[0].ERR);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        this.UGYFELLIST = Q.UGYFELLIST;


        let ufid = 0;
        for(let i=0; i<this.UGYFELLIST.length; i++)
        {
            if (this.UGYFELLIST[i].id == gDashboardUgyfelID) { ufid = this.UGYFELLIST[i].id; }
        }

        gDashboardUgyfelID = ufid;


        this.$refs.cboUgyfel.SetDataSource(this.UGYFELLIST);
        this.$refs.cboUgyfel.SetValue(gDashboardUgyfelID);


        if (Q.MISC[0].RedirUrl != "")
        {
            document.location = Q.MISC[0].RedirUrl;
            return;
        }

        this.LoadWidgets();
    },


    SetControlToFocus(pNextComp)
    {
      if (pNextComp == "") { return; }
      this.$refs[pNextComp].SetFocus();
    },


    async ShowDialog(pText)
    {
        var DialogResult = "";
        await this.$refs.Dialog.Alert("Hiba", pText).then(res => { DialogResult = res; });
       
    },



  },
  created()
  {

  },
  mounted()
  {
    this.SetLang();

    
  }

}


</script>


<style scoped>

.nrm_col1
{
    width:50%;
    box-sizing:border-box;
    vertical-align: top;
    display:inline-block;
    text-align:left;
    padding:10px 5px 10px 0px;
}

.nrm_col2
{
    width:50%;
    box-sizing:border-box;
    vertical-align: top;
    display:inline-block;
    text-align:left;
    padding:30px 0px 10px 5px;
}

@media(max-width:600px)
{
    .nrm_col1
    {
        width:100%;
        padding:10px 0px;
    }

    .nrm_col2
    {
        width:100%;
        padding:10px 0px;
        text-align: center;
    }

}


</style>